<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createFireAlarm"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Add New</span>
      </b-button>
    </div>

    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="site"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Building"
              label-for="building"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <v-select
                label="name"
                v-model="building"
                placeholder="Select Building"
                :options="buildings"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="fire_alarms"
        details-td-class="m-1 p-1"
        small
        v-if="hasPermission('read_fire_alarm')"
        :per-page="0"
      >
        

        <template #cell(site_data)="row">
          {{
            row.item.site_data ? row.item.site_data.name : ""
          }}
        </template>

        <template #cell(building_data)="row">
          {{
            row.item.building_data ? row.item.building_data.name : ""
          }}
        </template>

        <template #cell(device_data)="row">
          {{
            row.item.building_data ? row.item.building_data.ase_number : ""
          }}
        </template>

        <template #cell(status)="row">
          {{
            row.item.status === true ? "Enabled" : "Disabled"
          }}
        </template>


        <template #cell(is_false)="row">
          {{
            row.item.is_false === true ? "Yes" : "No"
          }}
        </template>

        
        <template #cell(manage)="row">
          <b-button
            variant="success"
            pill
            size="sm"
            class="mr-50"
            @click="falseAlarm(row.item)"
            v-if="hasPermission('update_fire_alarm')"
            :disabled="row.item.is_false === true ? true:false"
          >
            False Alarm
          </b-button>

          <b-button
            variant="success"
            pill
            size="sm"
            class="mr-50"
            @click="deactivateAlarm(row.item)"
            v-if="hasPermission('update_fire_alarm')"
            :disabled="row.item.status === true ? false:true"
          >
            Deactivate Alarm
          </b-button>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <CreateFireAlarmModal
      @modalClosed="onModalClosed"
      :key="`create-${createFireAlarmModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateFireAlarmModal from "@/components/fire_alarm/CreateFireAlarmModal.vue";
import util from "@/util.js";
import VueGauge from 'vue-gauge';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";



export default {
  components: {
    CreateFireAlarmModal,
    VueSelectPaginated,
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "site_data", label: "Site" },
        { key: "building_data", label: "Building" },
        { key: "device_data", label: "ASE #" },
        { key: "status", label: "status" },
        { key: "is_false", label: "False Alarm" },
        { key: "created_at", label: "Date/Time" },
        { key: "manage", label: "Actions" },
      ],
      
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      fire_alarms: [],
      fire_alarm: null,
      createFireAlarmModalCount: 0,
      searchTypes: [
        { value: 1, name: "Site" },
        { value: 2, name: "Building" },
      ],
      searchType: null,
      name: "",
      site: "",
      sites: [],
      buildings: [],
      building : "",
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();

    const sites =  await this.getSitesDDL();
    this.sites = sites.data;

    const buildings = await this.getBuildingsDDL();
    this.buildings = buildings.data;
  },
  methods: {
    ...mapActions({
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getFireAlarms: "appData/getFireAlarms",
      updateFireAlarm: "appData/updateFireAlarm",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.building = "";
            break;
          case 2:
            this.site = "";
            break;         
        }
      } else {
        this.site = "";
        this.building = "";

      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getFireAlarms({
          pageNumber: this.currentPage,      
          site: this.site,      
          building: this.building,
        });
        this.fire_alarms = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    createFireAlarm() {
      this.createFireAlarmModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-fire-alarm-modal");
      });
    },
    async falseAlarm(fire_alarm) {
      try {
        const formData = new FormData();
        formData.append("is_false", true);
        formData.append("status", false);
        const res = await this.updateFireAlarm({
          payload: formData,
          pk: fire_alarm.id,
        });
        console.log(res.status);
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Fire Alarm Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          await this.fetchPaginatedData();
        }
      } catch (error) {
        this.displayError(error);
      }      
    },

    async deactivateAlarm(fire_alarm) {
      try {
        const formData = new FormData();
        formData.append("status", false);
        const res = await this.updateFireAlarm({
          payload: formData,
          pk: fire_alarm.id,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Fire Alarm Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          await this.fetchPaginatedData();
        }
      } catch (error) {
        this.displayError(error);
      }      
    },

    async removeFireAlarm(fire_alarm) {
      this.fire_alarm = fire_alarm;
      try {
        const res = await this.deleteFireAlarm({
          pk: this.dfire_alarm.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "FireAlarm deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
